import { type AppRouter } from "@platform/trpc";
import { createTRPCClient, httpBatchLink } from "@trpc/client";
import { createTRPCOptionsProxy } from "@trpc/tanstack-react-query";
import config from "~/config";
import { queryClient } from "~/shared/api/core/query-client";
import { getImpersonationState } from "~/shared/components/PrivateAppLayout/components/Impersonation";
import { authenticationTokenRefresh } from "~/shared/lib/cognito/helpers/authentication-token-refresh";

export const trpcClient = createTRPCClient<AppRouter>({
  links: [
    httpBatchLink({
      url: config.trpc,
      headers: getHeaders,
    }),
  ],
});

export const trpc = createTRPCOptionsProxy<AppRouter>({
  client: trpcClient,
  queryClient,
});

async function getHeaders(): Promise<Record<string, string>> {
  const headers: Record<string, string> = {};

  try {
    const token = await authenticationTokenRefresh();
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    const impersonationState = getImpersonationState();
    if (impersonationState != null) {
      headers["X-BL-Impersonate"] = impersonationState.username;
    }
  } catch {
    // Continue without auth if token refresh fails
  }

  return headers;
}
